
$(document).on('turbolinks:load', function(event) {
    $(document).on("keydown", ":input:not(textarea)", function (event) {
        if (event.key == "Enter") {
            event.preventDefault();
        }
    });
})
